// extracted by mini-css-extract-plugin
export default {"bodybg":"index_bodybg_JNL0x"};